// 9fbef606107a605d69c0edbcd8029e5d
const labelsObj = {
  account: {
    common: {
      lbl_rnr_summary_title: 'Overview',
      lbl_rnr_summary_content:
        'Write a detailed review about your previous purchases. Reviews will be posted on the product page.',
      lbl_rnr_product_to_review: 'Products to be Reviewed',
      lbl_rnr_product_reviewed: 'Products Reviewed',
      lbl_rnr_account_placeholder: 'Share some thoughts about this purchase',
      lbl_rnr_review_modal_heading: 'Review Your Previous Purchases',
      lbl_rnr_your_review: 'Your Review',
      lbl_rnr_review_your_products: 'Review Your Products',
      lbl_rnr_no_product_found:
        "Add a review with details and ratings on items  you've purchased when they start to appear.",
      lbl_rnr_main_title: 'Rate & Review',
      lbl_rnr_thank_you_note: 'Thank you #name for your valuable review!',
      lbl_rnr_previously_reviwed_products: 'Previously Reviewed Products',
      lbl_rnr_modal_header: 'Rate & Review Your Purchases',
      lbl_rnr_review_submitted: 'Review Submitted',
      lbl_rnr_review_submit_success:
        'Thank you! We are processing your review, this may take a few days.',
      lbl_rnr_tap_to_rate: 'tap to rate',
      lbl_rnr_textarea_placeholder:
        'What did you like or dislike? What did you use this product for?',
    },
    preferences: {
      lbl_termsAndConditionsPage_link: '/help-center/policies/TermsandConditions',
    },
    orders: {
      lbl_orders_load_more: 'LOAD MORE ',
    },
  },
  global: {
    errorMessages: {
      lbl_errorMessages_enterReviewError: 'Please enter a review',
      lbl_errorMessages_reviewCharacterError: 'Please use at least 50 characters in your review',
      lbl_errorMessages_CWXFR0230E: 'Oops, something went wrong. Please retry!',
      lbl_errorMessages_starRatingError: 'Please provide a star rating to submit your review',
    },
    cartItemTile: {
      lbl_view_all: 'View All',
    },
  },
  ProductDetailPage: {
    PDP_Sub: {
      lbl_write_review: 'Write A Review',
      lbl_rnr_review_success: 'We have received your review for',
      lbl_modal_heading: 'Complete Your Review',
      lbl_rnr_placeholder: 'Tell us how you feel about this purchase',
      lbl_rnr_rating_success: 'Rating submitted!',
      lbl_view_more: 'View more',
      lbl_rnr_review_another_purchases: 'RATE & REVIEW ANOTHER PURCHASE',
      lbl_rnr_review_other_purchases: 'Review your other purchases',
      lbl_review_pastPurchases: 'Review Your Purchases',
      lbl_be_first_to_review: 'Be the first to review! ',
    },
  },
  Browse: {
    PDP: {
      lbl_write_review_agreement: 'By submitting this review, I agree to the',
      lbl_write_review_post_review: 'SUBMIT',
      lbl_write_review_click_to_rate: 'Click to rate!',
    },
  },
  checkout: {
    checkoutHeader: {
      lbl_checkoutHeader_review: 'Review',
    },
  },
};

export default labelsObj;
